import type {
  FormEventHandler,
  FunctionComponent,
  PropsWithChildren,
} from 'react';

import { withForwardedEnv } from '../../config/forwardedEnv';
import FlowParameters from './FlowParameters';

type ConsentFormProps = PropsWithChildren<{
  action?: string;
  onSubmit?: FormEventHandler<HTMLFormElement>;
}>;

const ConsentForm: FunctionComponent<ConsentFormProps> = ({
  children,
  action = '/authorize/resume',
  onSubmit,
}) => {
  return (
    <form action={withForwardedEnv(action)} method="post" onSubmit={onSubmit}>
      <FlowParameters />
      {children}
    </form>
  );
};
export default ConsentForm;
